<template>
  <qx-card-form title="收款信息">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <section slot="receiver" slot-scope="prop">
        <ChooseReceiver
          style="float: left"
          :isRadio="true"
          v-model="prop.form.receiver"
          @beforeSub="beforeSub"
          @change="handleReceiverChange"
          :otherSearchData="{
            userType: userType,
          }"
          :fnRadioDisabled="
            (item) => {
              let disabled = false;
              if ($route.query.loanType === '1') {
                if (item.userType !== Number(userType)) {
                  disabled = true;
                }
              }
              return disabled;
            }
          "
        />
        <span style="margin-left: 16px" class="error">
          <span v-if="$route.query.loanType === '1'">收款人只能选择司机</span>
          <span
            v-if="
              $route.query.loanType === '2' || $route.query.loanType === '3'
            "
          >如果替代他人填报，则收款人请选择实际借款人！</span>
        </span>
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  mapState,
} from 'vuex';
import ChooseReceiver from 'components/choose/receiver';
import { getReceiverList } from 'api';
export default {
  components: {
    ChooseReceiver,
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
    userType () {
      let _userType = -1;
      if (this.$route.query.loanType === '1') {
        _userType = '3';
      }
      return _userType;
    },
  },
  data () {
    return {
      baseForm: {
        orgIdOptions: [],
        form: [
          {
            label: '收款人',
            value: 'receiver',
            slot: true,
            default: {},
          },
          {
            label: '收款手机',
            value: 'receiverPhone',
            type: 'input',
            disabled: true,
          },
          {
            label: '银行户名',
            value: 'accName',
            type: 'input',
            disabled: true,
          },
          {
            label: '银行账号',
            value: 'accNo',
            type: 'input',
            disabled: true,
          },
          {
            label: '开户银行',
            value: 'bankName',
            type: 'input',
            disabled: true,
          },
        ],
        rules: {
          receiver: [
            { required: true, message: '请选择收款人', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    beforeSub (receiverComp) {
      const userTypeOptionsBackup = receiverComp.userTypeOptionsBackup;
      receiverComp.searchBoxDataTmpl.userTypeOptions = userTypeOptionsBackup;
      let replaceOptions = [];
      if (this.$route.query.loanType === '1') {
        for (let item of userTypeOptionsBackup) {
          if (item.value === '3') {
            replaceOptions.push(item);
          }
        }
        receiverComp.searchBoxDataTmpl.userTypeOptions = replaceOptions;
      }
    },

    handleReceiverChange (receiver) { // 收款人变化
      this.$refs.baseForm.setVal('receiverPhone', receiver.receiverPhone); // 收款手机
      this.$refs.baseForm.setVal('accName', receiver.acctName); // 银行户名
      this.$refs.baseForm.setVal('accNo', receiver.acctNo); // 银行账号
      this.$refs.baseForm.setVal('bankName', receiver.bankName); // 开户银行
    },

    // 设置默认的收款人
    async setDefaultReceiver () {
      if (this.userInfo.staffTFInfo && this.userInfo.staffTFInfo.linkman) {
        const resReceiverList = await getReceiverList({
          userType: -1,
          userId: this.userInfo.staffTFInfo.userId,
        });
        if (resReceiverList && resReceiverList.items && resReceiverList.items.length) {
          let receiverInfo = resReceiverList.items[0];
          const receiver = {
            userType: receiverInfo.userType, // 收款方类型
            receiverName: receiverInfo.receiverMan, // 收款人
            userId: receiverInfo.userId, // 收款方ID
            receiverPhone: receiverInfo.receiverPhone, // 收款手机
            acctName: receiverInfo.acctName, // 银行户名
            accNo: receiverInfo.acctNo, // 银行账号
            bankName: receiverInfo.bankName, // 开户银行
          };
          this.$refs.baseForm.setVal('receiver', receiver);
          this.$refs.baseForm.setVal('receiverPhone', receiverInfo.receiverPhone);
          this.$refs.baseForm.setVal('accName', receiverInfo.acctName); // 银行户名
          this.$refs.baseForm.setVal('accNo', receiverInfo.acctNo); // 银行账号
          this.$refs.baseForm.setVal('bankName', receiverInfo.bankName); // 开户银行
        }
      }
    },

    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData.receUserType = formData.receiver.userType; // 收款方类型
        formData.receiverMan = formData.receiver.receiverName; // 收款人
        formData.receUserId = formData.receiver.userId; // 收款方ID
        delete formData.receiver;
      }
      return formData;
    },

    async sub () {
      const formData = await this.handleSubData();
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    init (data = {}) {
      data.receiver = {
        userType: data.receUserType, // 收款方类型
        receiverName: data.receiverMan || data.borrowName, // 收款人
        userId: data.receUserId || data.borrowUserId, // 收款方ID
        receiverPhone: data.receiverPhone || data.borrowPhone, // 收款手机
        acctName: data.accName, // 银行户名
        accNo: data.acctNo, // 银行账号
        bankName: data.bankName, // 开户银行
      };
      data.receiverPhone = data.receiverPhone || data.borrowPhone;
      this.$refs.baseForm.setVal('form', data);
      if (!data.receiverMan) {
        this.setDefaultReceiver();
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>
